var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.61705 11.92H1.93705V17.68C1.93705 18.1892 2.13934 18.6776 2.49941 19.0376C2.85948 19.3977 3.34784 19.6 3.85705 19.6H17.2971C17.8063 19.6 18.2946 19.3977 18.6547 19.0376C19.0148 18.6776 19.2171 18.1892 19.2171 17.68V11.92H11.5371V13.84H9.61705V11.92ZM9.61705 10.96H0.977051V5.2C0.977051 4.144 1.84105 3.28 2.89705 3.28H6.73705V2.32C6.73705 1.81078 6.93934 1.32242 7.29941 0.962355C7.65948 0.602285 8.14784 0.4 8.65705 0.4L12.4971 0.4C13.0063 0.4 13.4946 0.602285 13.8547 0.962355C14.2148 1.32242 14.4171 1.81078 14.4171 2.32V3.28H18.2571C18.7663 3.28 19.2546 3.48228 19.6147 3.84235C19.9748 4.20242 20.1771 4.69078 20.1771 5.2V10.96H11.5371V9.04H9.61705V10.96ZM12.4971 3.28V2.32H8.65705V3.28H12.4971Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(0.977051 0.4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.4f6d4d080ad9b3130b886e82c00a6664.svg";
export { ForwardRef as ReactComponent };